// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__Z1zuL","title":"Images90_title__2VGMC","images":"Images90_images__3z0Da"};